"use client";

import React, { createContext, useContext, useEffect, useState } from "react";
import { getSoundEngine, SoundEngine } from "@/lib/soundEngine";

type SoundContextType = {
  engine: SoundEngine | null;
  isMuted: boolean | null;
  mute: (value: boolean) => void;
};

const SoundContext = createContext<SoundContextType>({
  engine: null,
  isMuted: null,
  mute: () => {},
});

export const SoundProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [engine, setEngine] = useState<SoundEngine | null>(null);
  const [isMuted, setMuted] = useState<boolean | null>(null);

  useEffect(() => {
    const sound = getSoundEngine();
    if (sound) {
      setEngine(sound);
      const stored = localStorage.getItem("isMuted");
      if (stored !== null) {
        const muted = stored === "true";
        sound.muteAll(muted);
        setMuted(muted);
      }
    }
  }, []);

  const mute = (value: boolean) => {
    if (engine) {
      engine.muteAll(value);
      setMuted(value);
      localStorage.setItem("isMuted", value.toString());
    }
  };

  return (
    <SoundContext.Provider value={{ engine, isMuted, mute }}>
      {children}
    </SoundContext.Provider>
  );
};

export const useSound = () => useContext(SoundContext);
